import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Layout } from "./Layout";
import { ThemeProvider } from "@aws-amplify/ui-react";
import { theme } from "./theme";
import { ReactComponent as Logo } from './logo.svg';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <link rel='stylesheet' id='google-fonts-style-css' href='https://fonts.googleapis.com/css?family=Raleway%3A400%7CGrenze%3A400%7COpen+Sans%3A400%2C600%2C700%7CRoboto%3A400%2C500%2C700%7CGrenze%3A500%2C400%2C700%7CRaleway%3A500%2C600%2C400%2C700&#038;display=swap&#038;ver=12.6' type='text/css' media='all'/>
      <div className="header">
        <div className="header-logo-wrapper">
          <div className="header-logo-container">
            <a className="header-logo-a" href="https://www.lscoba.com/">
              <Logo />
              <span className="tdb-logo-text-wrap">
                <span className="tdb-logo-text-title">La Salle College</span>
                <span className="tdb-logo-text-tagline">
                  Old Boys' Association
                </span>
              </span>
            </a>
          </div>
        </div>
      </div>
      <Layout>
        <App />
      </Layout>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
